export type LatestRequest = {
  signal: AbortSignal;
  isCurrent: () => boolean;
  finish: () => void;
};

export const createLatestRequest = () => {
  let generation = 0;
  let controller: AbortController | null = null;

  return {
    begin(): LatestRequest {
      controller?.abort();
      const currentController = new AbortController();
      const currentGeneration = ++generation;
      controller = currentController;

      return {
        signal: currentController.signal,
        isCurrent: () =>
          generation === currentGeneration &&
          controller === currentController &&
          !currentController.signal.aborted,
        finish: () => {
          if (controller === currentController) controller = null;
        },
      };
    },
    reset() {
      controller?.abort();
      controller = null;
      generation += 1;
    },
  };
};

export const isAbortError = (error: unknown): boolean =>
  error instanceof DOMException
    ? error.name === "AbortError"
    : error instanceof Error && error.name === "AbortError";
